import VueCookie from 'vue-cookie';

export default {
    loading: (state) => state.loading,
    authorized: (state) => state.authorized,
    languages: (state) => state.languages,
    languageSelected: (state) => state.languageSelected,
    member: (state) => state.member,
    accounts: (state) => state.accounts,
    bluAccount: (state) => state.bluAccount,
    usdtAccount: (state) => state.usdtAccount,
    btcAccount: (state) => state.btcAccount,
    ethAccount: (state) => state.ethAccount,
    realtAccount: (state) => state.realtAccount,
    joinPool:(state) => state.joinPool,
    bluValue: (state) => state.bluValue,
    btcValue: (state) => state.btcValue,
    ethValue: (state) => state.ethValue,
    xemValue: (state) => state.xemValue,
    zarValue: (state) => state.zarValue,
    eurValue: (state) => state.eurValue,
    gbpValue: (state) => state.gbpValue,
    chfValue: (state) => state.chfValue,
    cnyValue: (state) => state.cnyValue,
    hkdValue: (state) => state.hkdValue,
    rasValue: (state) => state.rasValue,
    cadValue: (state) => state.cadValue,
    audValue: (state) => state.audValue,
    usdtValue: (state) => state.usdtValue,
    accountSelected: (state) => state.accountSelected,
    fees: (state) => state.fees,
    feeRedeem: (state) => state.feeRedeem,
    feePurchase: (state) => state.feePurchase,
    currencies: (state) => state.currencies,
    assetList: (state) => state.assetList,
    fundValueBtc: (state) => state.fundValueBtc,
    minimumInvestiment: (state) => state.minimumInvestiment,
    authCookie: (state) => {
        state.authCookie = VueCookie.get("BLUE");
        return state.authCookie
    },
    languageCookie: (state) => {
        state.languageCookie = VueCookie.get("BLUE-LANG");
        return state.languageCookie
    }
}


// WEBPACK FOOTER //
// ./src/store/getters.js